import React from 'react'
import { 
    Button, 
    Row, 
    Col, 
    Typography, 
} from "antd";
import { 
    PlusCircleOutlined,
} from '@ant-design/icons';
import {Link } from 'react-router-dom';
import ListaVideos from './ListaVideos';
import '../styles/AdminVideos.less';

const AdminView = () => {
    
    const { Title } = Typography;

    return (
        <>
            <Row gutter={{ xs: 10, sm: 10, md: 10, lg: 10}}>
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 13, offset: 0 }} 
                    md={{  span: 12, offset: 0 }} 
                    lg={{  span: 12, offset: 0 }}  
                    xxl={{ span: 12, offset: 0 }}
                >
                    <Title level={4}>Administrador de videos</Title>
                </Col>
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 7, offset: 4 }} 
                    md={{  span: 5, offset: 7 }} 
                    lg={{  span: 4, offset: 8 }}  
                    xxl={{ span: 3, offset: 9  }}
                >
                    <Link to='/admin/agregar'>

                        <Button 
                            type='primary'
                            size="large"
                            block
                            icon={ <PlusCircleOutlined /> }
                            >Agregar
                        </Button>
                    </Link>
                </Col>
            </Row>
            

            <ListaVideos />

        </>
    )
}

export default AdminView